import { supportApi } from '../../shared';
import { IFoodRestriction, ISaveFoodRestriction } from '../models';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class FoodRestrictionClient extends NewBaseClient<ISaveFoodRestriction, IFoodRestriction> {
    constructor() {
        super(supportApi, '/food-restrictions');
    }
}

export const foodRestrictionClient = new FoodRestrictionClient();
